import { DATA_TYPES } from "../filterConstants"
import { NumberFilter } from "./numberFilter"

export class PercentFilter extends NumberFilter {
  constructor(filterName, filterType, dataScopes, information, visibility, restrictedToScope) {
    super(filterName, filterType, dataScopes, information, visibility, restrictedToScope)
    this.dataType = DATA_TYPES.PERCENT
  }
}
